import { useEffect } from "react";

export const PIE_CHART = 'pie';
export const BAR_CHART = 'bar';

export const barOptions = {
  indexAxis: 'y',
  // Elements options apply to all of the options unless overridden in a dataset
  // In this case, we are setting the border of each horizontal bar to be 2px wide
  elements: {
    bar: {
      borderWidth: 1,
      borderColor: [
        'rgba(255,255,255,1)',
      ],
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: 'bottom',
    },
    title: {
      display: true,
      text: '',
    },
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true
    }
  }
};

export const barVerticalOptions = {
  // Elements options apply to all of the options unless overridden in a dataset
  // In this case, we are setting the border of each horizontal bar to be 2px wide
  elements: {
    bar: {
      borderWidth: 1,
      borderColor: [
        'rgba(255,255,255,1)',
      ],
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: 'bottom',
    },
    title: {
      display: true,
      text: '',
    },
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true
    }
  }
};

export const pieOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom',
    },
    title: {
      display: true,
      text: '',
    },
  },
}

export const useStackedChartData = ({ data, labels }) => {
  
  useEffect(() => {
    if (data) {
      getDatasets();
    }
  }, [data]);

  const getDatasets = () => {
    console.log(data);
  }

  return {
    labels: data.reduce((arr, item) => {
      return [...arr, item.name];
    }, []),
    datasets: [
      {
        label: 'Fit',
        data: [14,12],
        backgroundColor: colorOptions[0],
      },
      {
        label: 'Non Fit',
        data: [5,21],
        backgroundColor: colorOptions[1],
      },
    ],
  };
}

export const useChartData = ({ data, type, label }) => {
  const getBorderWidth = () => {
    if (type === PIE_CHART) {
      return 2;
    }
    return 0;
  }
  const getColorOptions = () => {
    if (type === BAR_CHART) {
      return colorOptions[3];
    }

    return colorOptions;
  }
  return {
    labels: data.reduce((arr, item) => {
      return [...arr, item.name];
    },[]),
    datasets: [
      {
        label: label,
        data: data.reduce((arr, item) => {
          return [...arr, item.value];
        },[]),
        backgroundColor: getColorOptions(),
        borderWidth: getBorderWidth(),
      },
    ],
  };
}

const opacity = `0.9`;
export const colorOptions = [
  `rgba(255, 99, 132, ${opacity})`,
  `rgba(54, 162, 235, ${opacity})`,
  `rgba(255, 206, 86, ${opacity})`,
  `rgba(75, 192, 192, ${opacity})`,
  `rgba(153, 102, 255, ${opacity})`,
  `rgba(255, 159, 64, ${opacity})`,
  `rgba(158, 62, 103, ${opacity})`,
  `rgba(252, 106, 33, ${opacity})`,
  `rgba(35, 247, 240, ${opacity})`,
  `rgba(194, 161, 202, ${opacity})`,
  `rgba(224, 70, 200, ${opacity})`,
  `rgba(160, 199, 152, ${opacity})`
];